export enum MFAErrorCode {
  MFA_CODE_IS_INVALID = '2FA_CODE_IS_INVALID',
  MFA_CODE_IS_REQUIRED = '2FA_CODE_IS_REQUIRED',
  MFA_CODE_SENT_TO_EMAIL = '2FA_CODE_SENT_TO_EMAIL',
  MFA_CODE_SENT_TO_PHONE = '2FA_CODE_SENT_TO_PHONE',
  MFA_REQUIRED = '2FA_REQUIRED',
}
